import { EConsentStatusChangedDetail } from '@/constants/econsent';
import { AppUserInfo } from '@/models/AppViewModel';
import { EConsentStatusRequest } from '@/store/eConsentApi';
import { EConsentAppUserInfo } from './useEConsent';

interface EConsentProfile {
  FirstName?: string;
  LastName?: string;
  EmailAddress?: string;
}

const EConsentUtility = () => {
  function getTrimmedExternalId(
    userInfo: EConsentAppUserInfo | undefined,
  ): string | null {
    const externalId = userInfo?.ExternalId?.trim();
    return externalId ? externalId : null;
  }

  function buildConsentStatusRequest(
    userInfo: AppUserInfo | undefined,
    advisorGroupId: number | null,
    profile: EConsentProfile | undefined,
  ): EConsentStatusRequest | null {
    const externalId = getTrimmedExternalId(userInfo);
    const firstName = profile?.FirstName?.trim();
    const lastName = profile?.LastName?.trim();
    const email = profile?.EmailAddress?.trim();

    if (
      !userInfo?.UserId ||
      advisorGroupId === null ||
      !firstName ||
      !lastName ||
      !email
    ) {
      return null;
    }

    return {
      user_id: userInfo.UserId,
      fi_id: advisorGroupId,
      external_id: externalId ?? '',
      first_name: firstName,
      last_name: lastName,
      email,
    };
  }

  function doesSubmittedStatusMatchRequest(
    status: EConsentStatusChangedDetail | null,
    request: EConsentStatusRequest,
  ): boolean {
    if (!status?.submitted) {
      return false;
    }

    if (status.userId !== undefined && status.userId !== request.user_id) {
      return false;
    }

    if (
      status.advisorGroupId !== undefined &&
      status.advisorGroupId !== request.fi_id
    ) {
      return false;
    }

    return true;
  }

  return {
    getTrimmedExternalId,
    buildConsentStatusRequest,
    doesSubmittedStatusMatchRequest,
  };
};

export default EConsentUtility();
